import React from 'react';
import { InterfaceType } from '../../../types';
import GraphLine from "../GraphLine/GraphLine";

interface Props {
    data: Array<any> | 'loading';
    Filters: JSX.Element | JSX.Element[];
    Analyse: JSX.Element | JSX.Element[];
    live: boolean;
    interface_id: string;
    graphValues: Array<string>;
    Interfaces: Array<InterfaceType>;
    equipment_id: string;
}

class Gigue extends React.Component<Props> {
    render() {
        const { data, Filters, Analyse, Interfaces, live } = this.props;
        return (
            <>
                <div className={'ctn__graph__lines'}>
                    {Filters}
                    <div className={'ctn__graphs'}>
                        <div className={'ctn__graph__line'}>
                            {/*<GraphLines*/}
                            {/*    containerName={'Gigue'}*/}
                            {/*    graphName={'jitter'}*/}
                            {/*    live={live}*/}
                            {/*    data={data}*/}
                            {/*    valuesLines={graphValues}*/}
                            {/*    Interfaces={Interfaces}*/}
                            {/*    equipment_id={equipment_id}*/}
                            {/*/>*/}
                            <GraphLine data={data} Interfaces={Interfaces} graphName={'jitter'}
                                valuesLines={['jitter']} live={live} ping={true} percent={false} />
                        </div>
                    </div>
                </div>
                {Analyse}
            </>
        );
    }
}

export default Gigue;
